module.exports = __webpack_public_path__ + "img/pr-10.8bd49b53.png";